import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {GeneralService} from "../../../../core/services/general.service";
import {TableService} from "../../../../core/services/table.service";
import {NgbDateStruct, NgbInputDatepicker} from "@ng-bootstrap/ng-bootstrap";
import {CommonSvgIconsComponent} from "../../../../shared/components/common-svg-icons/common-svg-icons.component";
import {VehicleService} from "../../../../core/services/vehicle.service";

@Component({
  selector: 'app-leasing-vehicle',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgbInputDatepicker,
    FormsModule,
    CommonSvgIconsComponent
  ],
  templateUrl: './leasing-vehicle.component.html',
  styleUrl: './leasing-vehicle.component.scss'
})
export class LeasingVehicleComponent {
  @Input() sharedData: any;
  public activeStep: number = 3;
  public validate: boolean = false;
  public leasingVehicleForm: FormGroup;
  @Output() activeSteps = new EventEmitter<number>();
  //public inputDatepickerModel: NgbDateStruct;

  constructor(private fb: FormBuilder, private generalService: GeneralService,private tableService: TableService, private vehicleService:VehicleService) {
    this.leasingVehicleForm = new FormGroup({
      vehicleId: new FormControl(""),
      expirationDate: new FormControl<NgbDateStruct | null>(null, Validators.required),
      term: new FormControl("",[
        Validators.required,
        Validators.pattern("^[0-9]+$") // Solo permite números
      ]),
      contractNumber: new FormControl(""),
      commission: new FormControl("", Validators.required),
      consideration: new FormControl("", Validators.required),
      estimatedResidual: new FormControl("", Validators.required),
    });
  }

  ngOnInit(): void {
    this.leasingVehicleForm.reset();
    this.findLeasing();
  }

  /*
     * Función para encontrar un trámite registrado para este Vehíuclo
     */
  findLeasing(){
    this.vehicleService.findLeasing(this.sharedData.vehicleId).subscribe(
        (res: any) => {
          if (res.error) {
            this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
          } else {
            if(res.data != 0) {
              this.leasingVehicleForm.patchValue(res.data);
              this.leasingVehicleForm.patchValue({
                'expirationDate':this.convertToDatepickerFormat(res.data.expirationDate)
              });
              this.generalService.showMessage('success', res.message);
            } else {
              this.generalService.showMessage('success', res.message);
            }
          }
        },
        (err) => {
          this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
        }
    )
  }

  /*
   * Función para guardar y/o editar y continuar con el siguiente form
   */
  next() {
    //const number = this.activeStep + 1;
    //this.activeSteps.emit(number);
    if (this.leasingVehicleForm.invalid) {
      this.validate = true;
    } else {
      this.leasingVehicleForm.get('vehicleId')?.setValue(this.sharedData.vehicleId);
      this.vehicleService.addVehicleLeasing(this.leasingVehicleForm.value).subscribe(
          (res: any) => {
            if (res.error) {
              this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
            } else {
              this.generalService.showMessage('success', res.message);
              const number = this.activeStep + 1;
              this.activeSteps.emit(number);
            }
          },
          (err) => {
            this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
          }
      );
    }
  }

  /*
   * Funcion para convertir la fecha al formato de data picker
   */
  convertToDatepickerFormat(dateString: string): { year: number, month: number, day: number } {
    const [year, month, day] = dateString.split('-').map(Number);
    return { year, month, day };
  }
}
